import { css } from 'styled-components';

export default {
  elements: {
    tooltip: {
      primary: '#ffffff',
      warning: '#f8e71c',
      error: '#f9eaec',
    },
    button: {
      primary: css`
        background-color: #007aff;
        color: #fff;

        ${props =>
          !props.disabled &&
          `
          :hover {
            background-color: #288fff;
          }
          
          :active {
            background-color: #0071ec;
          }
        `}

        ${props =>
          props.disabled &&
          `
          background-color: #c2c5cc;
        `}
      `,
    },
  },
  colors: {
    white: '#ffffff',
    black: '#000000',
    grey: '#262729',
    blue: '#007aff',
    greyLight: '#919499',
    frenchGray: '#c2c5cc',
  },
  shape: {
    borderRadius: '4px',
    borderRadiusBig: '6px',
  },
};
